import React, {useReducer, useState} from 'react';
import {GMAPS_API_KEY} from '../../constants';
import SimpleReactValidator from 'simple-react-validator';
import LocationForm from './LocationForm';
import {isEmpty} from 'lodash';

const useLocationForm = ({
  onlyText,
  openByDefault,
  setDirty,
  hideInput,
  optional,
}: $TSFixMe) => {
  const [errors, setErrors] = useState({});
  const [validator] = useState(new SimpleReactValidator());

  const formReducer = (state: $TSFixMe, action: $TSFixMe) => {
    return {
      ...state,
      [action.field]: action.payload,
    };
  };

  const [address, dispatch] = useReducer(formReducer, {});

  const addressWithLatLng = () => {
    if (
      address.lat === null ||
      address.lng === null ||
      address.lat === undefined ||
      address.lng === undefined
    ) {
      return fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${address.province} ${address.city} ${address.street}&key=${GMAPS_API_KEY}`,
      )
        .then((res) => res.json())
        .then((res) => {
          if (
            res.status === 'ZERO_RESULTS' ||
            !res.results ||
            !res.results[0]
          ) {
            return null;
          }
          const lat = res.results[0].geometry.location.lat;
          const lng = res.results[0].geometry.location.lng;
          dispatch({field: 'lat', payload: lat});
          dispatch({field: 'lng', payload: lng});
          return {
            ...address,
            lat: lat,
            lng: lng,
          };
        })
        .catch((err) => {
          process.env.NODE_ENV === 'development' && console.error(err);
        });
    } else {
      return new Promise((resolve) => {
        resolve(address);
      });
    }
  };

  const validateField = (field: $TSFixMe) => {
    if (!validator.allValid()) {
      if (!validator.fieldValid(field)) {
        setErrors({...errors, [field]: true});
        validator.showMessageFor(field);
      }
      return;
    }
    setErrors({});
  };

  const getAddress = () => {
    if (!(optional && isEmpty(address))) {
      validateField('address');
      validateField('street');
      validateField('city');
      validateField('province');
      validateField('postal');
      if (validator.allValid()) {
        return addressWithLatLng();
      }
    }
    return new Promise((resolve) => {
      resolve(null);
    });
  };

  return [
    getAddress,
    <LocationForm
      dispatch={dispatch}
      address={address}
      validator={validator}
      validateField={validateField}
      onlyText={onlyText}
      openByDefault={openByDefault}
      setDirty={setDirty}
      hideInput={hideInput}
    />,
    dispatch,
    address,
  ] as const;
};

export default useLocationForm;
